<template>
    <dashboard-layout title="공고 지원현황" fullHeight>
        <template slot="contents">
            <!-- 필터 -->
            <!-- <applied-list-filter class="mb-16" /> -->
            <template v-if="items.length">
                <div class="applied-cards">
                    <v-card rounded="lg" outlined v-for="item in items" :key="item._id" class="applied-card">
                        <v-row no-gutters>
                            <v-col cols="12" md="auto" class="border-md-end min-w-md-200px min-w-lg-280px">
                                <v-layout justify-center align-center class="w-100 h-100 pa-20">
                                    <v-img :aspect-ratio="166 / 36" width="166" height="36" max-width="166" contain :src="item?.company?.logo?.url">
                                        <v-fade-transition>
                                            <v-overlay v-show="!item?.company?.logo?.url" absolute light color="white">
                                                <image-overlay>{{ item?.company?.name }}</image-overlay>
                                                <!-- <v-layout row align-center class="black--text">
                                                    <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                                    <span> {{ item?.company?.name }} </span>
                                                </v-layout> -->
                                            </v-overlay>
                                        </v-fade-transition>
                                    </v-img>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="" class="applied-card__info">
                                <div class="pa-20 pa-md-24">
                                    <v-row align="center" class="row--large">
                                        <v-col cols="12" md="" class="applied-card__detail mb-10 mb-md-0">
                                            <p class="page-text page-text--sm primary--text mb-4">{{ item?.company?.name }}</p>
                                            <a :href="`/recruitments/${item?.recruitment?._id}`" rel="noopener noreferrer" class="d-block page-text--lg font-wieght-medium mb-8 mb-lg-16">
                                                {{ item?.recruitment?.subject }}
                                            </a>
                                            <v-chip-group v-if="item?.recruitment?.employment?.typesTexts" class="mb-4">
                                                <v-chip v-for="text in item.recruitment.employment.typesTexts" :key="text" small outlined color="grey-d">
                                                    <span class="grey-6--text">
                                                        {{ text }}
                                                    </span>
                                                </v-chip>
                                            </v-chip-group>
                                            <p class="page-text grey-6--text ellip mb-8 mb-lg-16">
                                                {{ item?.recruitment?.summary }}
                                            </p>
                                            <recruitment-view-application :application="item?.recruitment?.application" />
                                        </v-col>
                                        <v-col cols="12" md="auto" class="mb-10 mb-md-0">
                                            <div class="min-w-80px">
                                                <p class="page-text--sm grey-9--text mb-4">상태</p>
                                                <v-layout align-center>
                                                    <div class="mr-4">
                                                        <i v-if="item?.state == 'ON_WRITING'" class="icon icon-dot icon-dot--green" />
                                                        <i v-else-if="item?.state == 'IS_APPLIED'" class="icon icon-dot icon-dot--primary" />
                                                        <i v-else-if="item?.state == 'IS_REVOKED'" class="icon icon-dot icon-dot--grey" />
                                                        <i v-else-if="item?.state == 'ON_RECRUIT'" class="icon icon-dot icon-dot--secondary" />
                                                    </div>
                                                    <h5 class="page-text--lg font-weight regular">
                                                        {{ item?.stateText }}
                                                    </h5>
                                                </v-layout>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="auto">
                                            <v-btn :disabled="item.state == APPLICATION_STATES.IS_REVOKED.value || item.state == APPLICATION_STATES.ON_RECRUIT.value" outlined small block color="primary" class="mw-lg-100px" @click="revoke(item)">지원취소</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                <!-- <v-card v-for="item in items" :key="item._id" outlined rounded="xl" class="mb-16">
                    <v-row align="center" class="ma-0">
                        <v-col cols="12" md="auto" class="px-lg-58 px-24 py-24">
                            <v-img class="mx-auto" width="166" height="36" :src="item?.company?.logo?.url">
                                <v-fade-transition>
                                    <v-overlay v-show="!item?.company?.logo?.url" absolute light color="white">
                                        <v-layout row align-center class="black--text">
                                            <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                            <span> {{ item?.company?.name }} </span>
                                        </v-layout>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>
                        </v-col>

                        <v-col cols="auto" class="align-self-stretch pa-0"> <v-divider class="d-none d-md-flex" vertical /> </v-col>

                        <v-col class="pa-0 pa-24">
                            <v-card-subtitle class="pb-0 pa-0 primary--text page-text-sm">{{ item?.company?.name }}</v-card-subtitle>
                            <v-card-title class="pt-0 pa-0 page-text--lg">
                                <a :href="`/recruitments/${item?.recruitment?._id}`" target="_blank" rel="noopener noreferrer"> {{ item?.recruitment?.subject }} </a>
                            </v-card-title>
                            <v-card-text class="pa-0 mt-8 mt-md-16">
                                <v-chip-group v-if="item?.recruitment?.employment?.typesTexts">
                                    <v-chip class="grey-6--text" v-for="text in item.recruitment.employment.typesTexts" :key="text" small outlined> {{ text }} </v-chip>
                                </v-chip-group>
                                <div class="mt-4 page-text grey-6--text ellip">{{ item?.recruitment?.summary }}</div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-16 page-text page-text--sm grey-9--text line-height-15"> <recruitment-view-application :application="item?.recruitment?.application" /> </v-card-actions>
                        </v-col>
                        <v-col cols="12" sm="1" lg="1" class="pa-24 pa-md-0">
                            <v-card-subtitle class="pb-0 pa-0 font-size-12">상태</v-card-subtitle>
                            <v-card-title class="pt-0 pa-0 page-text--lg"> <i class="icon icon-dot icon-dot--primary mr-4" />{{ item?.stateText }} </v-card-title>
                        </v-col>
                        <v-col cols="12" md="3" lg="auto" v-if="item.state != APPLICATION_STATES.IS_REVOKED.value">
                            <v-btn outlined small block color="primary" class="mw-lg-100px mb-4 mb-lg-8" @click="revoke(item)">지원취소</v-btn>
                        </v-col>
                    </v-row>
                </v-card> -->
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 사용자님. <br />
                        지원한 채용공고가 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 보러가기</span>
                    </v-btn>
                </v-layout>
                <!-- <v-layout column justify-center align-center class="text-center text-h4 font-weight-bold" style="height: calc(100% - 50px - 16px); line-height: 1.4">
                    안녕하세요, 사용자님. <br />
                    지원한 채용공고가 없습니다.
                    <v-btn x-large color="primary" class="my-24" href="/recruitments"> 채용공고 보러가기 </v-btn>
                </v-layout> -->
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import AppliedListFilter from "@/components/dashboard/person/applied-list-filter.vue";
import RecruitmentViewApplication from "@/components/client/recruitments/view/recruitment-view-application.vue";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        DashboardLayout,
        AppliedListFilter,
        RecruitmentViewApplication,
        ImageOverlay,
    },
    data: () => ({
        loading: false,
        applications: [],

        limit: 10,
        summary: { totalCount: 0 },
        APPLICATION_STATES,
    }),
    computed: {
        items() {
            return this.applications.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, applications } = await api.v1.person.recruitmentApplications.gets({
                    headers: { skip, limit },
                    params,
                });

                this.applications = applications;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        async revoke(item) {
            const go = confirm(`"${item?.recruitment?.subject}" 공고 지원서를 취소하시겠습니까?`);
            if (go) {
                if (this.loading) return;
                else this.loading = true;
                try {
                    await api.v1.person.recruitmentApplications.revoke(item);
                    alert("해당 지원서가 지원취소 되었습니다");
                } finally {
                    this.loading = false;
                    this.search();
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .applied-card__detail {
        max-width: calc(100% - 170px);
    }
}
@media (min-width: 1024px) {
    .applied-card__detail {
        max-width: calc(100% - 236px);
    }
}
@media (min-width: 1200px) {
}
</style>
